import Image from "next/image";
import Link from "next/link";

const GoogleAdLarge = () => {
  return (
    <>
      <div className="rbt-callto-action rbt-cta-default style-3 bg-gradient-3">
        <a href="https://www.tkqlhce.com/click-101154220-15829231" target="_top">
          <img src="https://www.ftjcfx.com/image-101154220-15829231" width="976" height="251" alt="" border="0" /></a>
      </div>
    </>
  );
};

export default GoogleAdLarge;
